export default "__VITE_ASSET__DiQ329Dc__"